import React, { Component } from "react";
import PropTypes from "prop-types";
import { reduxForm, Field, FieldArray, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import compose from "recompose/compose";
import find from "lodash.find";
import isNumber from "lodash.isnumber";
import getDefaultValues from "../components/form/getDefaultValues";
import {
  Responsive,
  Toolbar,
  required,
  GET_LIST,
  setSidebarVisibility
} from "admin-on-rest";
import { RestClient } from "../restClient";
import "./index.css";
import { styles } from "./styles";
import NavigationChevronRight from "material-ui/svg-icons/navigation/chevron-right";
import FlatButton from "material-ui/FlatButton";
import ContentAdd from "material-ui/svg-icons/content/add-circle";
import ActionDelete from "material-ui/svg-icons/action/highlight-off";
import MenuItem from "material-ui/MenuItem";
import Divider from "material-ui/Divider";
import {
  renderMultiTextField,
  renderDateField,
  renderTimeField,
  renderTextFieldView,
  renderSelectField
} from "./OrderFormField";
import {
  Table,
  TableBody,
  TableHeader,
  TableFooter,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from "material-ui/Table";
// import { Values } from 'redux-form-website-template';
import { TextField, SelectField } from "redux-form-material-ui";
import {
  DivContainer,
  DivStatus,
  HeaderForm,
  HeaderDateTime,
  HeaderTitle,
  DivCustomerInfo,
  DivCustomerInfoBox,
  DivCustomerInfoBox1,
  DivTotal,
  DivFieldTotal,
  DivOrderTotal,
  DivSubTotal
} from "./styled";

const isRequired = validate => {
  if (validate === required) return true;
  if (Array.isArray(validate)) {
    return validate.includes(required);
  }
  return false;
};

class OrderForm extends Component {
  handleSubmitWithRedirect = (redirect = this.props.redirect) =>
    this.props.handleSubmit(values => {
      // insert customer name with first name and lastname;
      //values.customer_info.name = values.customer_info.first_name +' ' + values.customer_info.last_name;
      this.props.save(values, redirect);
    });
  constructor(props) {
    super(props);

    this.state = {
      isShow: false,
      dataItems: [],
      isLoadItems: true,
      subtotal: 0,
      customTotal: 0,
      total_items: 0,
      custom: 0,
      coupon: 0,
      shipping: 0,
      total: 0,
      resetCustomerInfo: false
    };
    this.getProductSku();
  }
  componentWillMount() {
    this.props.setSidebarVisibility(false);
  }
  getProductSku = () => {
    RestClient(GET_LIST, "products/sku", {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "sku", order: "ASC" },
      filter: {}
    })
      .then(items => {
        this.setState({ dataItems: items.data });
      })
      .catch(e => {
        console.error(e);
      });
  };
  renderTItle = title => (
    <HeaderTitle>
      <h3>{title} </h3>{" "}
      <NavigationChevronRight
        style={styles.iconHeader}
        color={styles.headerTitle.color}
      />
    </HeaderTitle>
  );
  renderField = ({ input, ...rest }) => (
    <Field
      {...rest}
      {...input.props}
      name={input.props.source}
      component={input.type}
      isRequired={isRequired(input.props.validate)}
    />
  );
  renderItemsFieldsSmall = (items, index, fields) => {
    fields.get(index).subtotal =
      fields.get(index).qty * fields.get(index).price;
    return (
      <TableRow key={index}>
        <TableRowColumn style={{ height: "100%", whiteSpace: "normal" }}>
          <Field
            key={index}
            floatingLabelText="SKU"
            name={`${items}.sku`}
            component={SelectField}
            onChange={(event, value) =>
              this.onChangeItemSKU(event, value, index)
            }
            placeholder="item"
          >
            {this.state.dataItems.map((item, indexx) => {
              return (
                <MenuItem
                  value={item.sku}
                  key={indexx}
                  primaryText={item.sku}
                />
              );
            })}
          </Field>
          <Field
            floatingLabelText="Quantity"
            parse={v => v * 1}
            name={`${items}.qty`}
            component={TextField}
            onChange={(event, value) =>
              this.onChangeItemQuantity(event, value, index)
            }
            placeholder="0"
          />
          <Field
            floatingLabelText="Available"
            label="Available"
            name={`${items}.available`}
            component={renderTextFieldView}
            placeholder="available"
          />
          <Field
            floatingLabelText="Price"
            label="Price"
            name={`${items}.price`}
            parse={v => v * 1}
            component={renderTextFieldView}
            placeholder="price"
          />
          <Field
            floatingLabelText="Subtotal"
            label="Subtotal"
            name={`${items}.subtotal`}
            parse={v => v * 1}
            component={renderTextFieldView}
            placeholder="total"
          />
          <div style={{ textAlign: "right", marginBottom: 10 }}>
            <FlatButton
              primary
              label="Remove"
              onClick={() => fields.remove(index)}
              icon={<ActionDelete />}
            />
          </div>
        </TableRowColumn>
      </TableRow>
    );
  };
  renderItemsFields = (items, index, fields) => {
    fields.get(index).subtotal =
      fields.get(index).qty * fields.get(index).price;
    return (
      <TableRow key={index}>
        <TableRowColumn>
          <Field
            key={index}
            label="SKU"
            name={`${items}.sku`}
            component={SelectField}
            onChange={(event, value) =>
              this.onChangeItemSKU(event, value, index)
            }
            placeholder="item"
          >
            {this.state.dataItems.map((item, indexx) => {
              return (
                <MenuItem
                  value={item.sku}
                  key={indexx}
                  primaryText={item.sku}
                />
              );
            })}
          </Field>
        </TableRowColumn>
        <TableRowColumn style={{ width: 50 }}>
          <Field
            label=""
            parse={v => v * 1}
            name={`${items}.qty`}
            component={TextField}
            onChange={(event, value) =>
              this.onChangeItemQuantity(event, value, index)
            }
            placeholder="0"
          />
        </TableRowColumn>
        <TableRowColumn style={{ width: 50 }}>
          <Field
            label=""
            name={`${items}.available`}
            parse={v => v * 1}
            component={renderTextFieldView}
            placeholder="0"
          />
        </TableRowColumn>
        <TableRowColumn style={{ width: 50 }}>
          <Field
            label=""
            name={`${items}.price`}
            parse={v => v * 1}
            component={renderTextFieldView}
            placeholder="0"
          />
        </TableRowColumn>
        <TableRowColumn style={{ width: 80 }}>
          <Field
            label=""
            name={`${items}.subtotal`}
            parse={v => v * 1}
            component={renderTextFieldView}
            placeholder="0"
          />
        </TableRowColumn>
        <TableRowColumn style={{ textAlign: "right", width: 30 }}>
          <FlatButton
            primary
            label=""
            onClick={() => fields.remove(index)}
            icon={<ActionDelete />}
          />
        </TableRowColumn>
      </TableRow>
    );
  };
  renderItemList = ({ fields }) => {
    return (
      <Responsive
        small={
          <Table selectable={false}>
            <TableBody displayRowCheckbox={false}>
              {fields.map(this.renderItemsFieldsSmall)}
            </TableBody>
            <TableFooter adjustForCheckbox={false}>
              <TableRow>
                <TableRowColumn style={{ textAlign: "center" }}>
                  <FlatButton
                    primary
                    label="add another item"
                    onClick={() => fields.push({})}
                    icon={<ContentAdd />}
                  />
                </TableRowColumn>
              </TableRow>
            </TableFooter>
          </Table>
        }
        medium={
          <Table selectable={false}>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn tooltip="Item">Item</TableHeaderColumn>
                <TableHeaderColumn style={{ width: 50 }} tooltip="Quantity">
                  Quantity
                </TableHeaderColumn>
                <TableHeaderColumn style={{ width: 50 }} tooltip="Available">
                  Available
                </TableHeaderColumn>
                <TableHeaderColumn style={{ width: 50 }} tooltip="Price(Rp)">
                  Price(Rp)
                </TableHeaderColumn>
                <TableHeaderColumn style={{ width: 100 }} tooltip="Total">
                  Total(Rp)
                </TableHeaderColumn>
                <TableHeaderColumn style={{ width: 30 }} />
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
              {fields.map(this.renderItemsFields)}
            </TableBody>
            <TableFooter adjustForCheckbox={false}>
              <TableRow>
                <TableRowColumn style={{ textAlign: "center" }}>
                  <FlatButton
                    primary
                    label="add another item"
                    onClick={() => fields.push({})}
                    icon={<ContentAdd />}
                  />
                </TableRowColumn>
              </TableRow>
            </TableFooter>
          </Table>
        }
      />
    );
  };
  onChangeItemSKU = (event, value, index) => {
    let data = find(this.state.dataItems, { sku: value });
    let datatotal = this.props.items[index].qty * data.price;
    this.props.items[index].available = data.available;
    this.props.items[index].price = data.price;
    this.props.items[index].id = data.id;
    //this.props.items[index].qty = 0;
    if (isNumber(datatotal)) {
      this.props.items[index].subtotal = datatotal;
      this.handleItemsTotal();
    }
  };
  onChangeItemQuantity = (event, value, index) => {
    const value1 = parseFloat(value);
    if (isNumber(value1)) {
      this.props.items[index].qty = value1;
      this.props.items[index].subtotal = this.props.items[index].price * value1;
      this.handleItemsTotal();
    }
  };

  handleItemsTotal = () => {
    let subtotal = 0;
    let total_items = 0;
    let customItem = 0;
    if (this.props.customs != null && this.props.customs.length > 0) {
      customItem = this.props.customs.length;
    }
    if (this.props.items != null && this.props.items.length > 0) {
      for (let i = 0; i < this.props.items.length; i++) {
        if (!isNaN(this.props.items[i].subtotal)) {
          subtotal = this.props.items[i].subtotal + subtotal;
        }
      }
      total_items = this.props.items.length + customItem;
    } else {
      total_items = customItem;
    }

    let customTotal = this.state.customTotal;
    let total = customTotal + subtotal;

    this.setState({
      subtotal: subtotal,
      total: total
    });

    this.props.amounts.total = total;
    this.props.amounts.subtotal = subtotal;
    this.props.amounts.total_items = total_items;
  };

  renderCustomFieldsSmall = (customs, index, fields) => (
    <TableRow key={index}>
      <TableRowColumn style={{ height: "100%", whiteSpace: "normal" }}>
        <Field
          floatingLabelText="Variable"
          name={`${customs}.variable`}
          component={TextField}
          placeholder="variable"
        />
        <Field
          floatingLabelText="Quantity"
          name={`${customs}.qty`}
          parse={v => v * 1}
          component={TextField}
          onChange={(event, value) =>
            this.onChangeCustomQty(event, value, index)
          }
          placeholder="qty"
        />
        <Field
          floatingLabelText="Price"
          name={`${customs}.price`}
          parse={v => v * 1}
          component={TextField}
          onChange={(event, value) =>
            this.onChangeCustomPrice(event, value, index)
          }
          placeholder="price"
        />
        <Field
          floatingLabelText="Subtotal"
          label="Subtotal"
          name={`${customs}.subtotal`}
          parse={v => v * 1}
          component={renderTextFieldView}
          placeholder="total"
        />
        <div style={{ textAlign: "right", marginBottom: 10 }}>
          <FlatButton
            primary
            label="Remove"
            onClick={() => fields.remove(index)}
            icon={<ActionDelete />}
          />
        </div>
      </TableRowColumn>
    </TableRow>
  );
  renderCustomFields = (customs, index, fields) => (
    <TableRow key={index}>
      <TableRowColumn>
        <Field
          label=""
          name={`${customs}.variable`}
          component={TextField}
          placeholder="variable"
        />
      </TableRowColumn>
      <TableRowColumn style={{ width: 50 }}>
        <Field
          label=""
          name={`${customs}.qty`}
          parse={v => v * 1}
          component={TextField}
          onChange={(event, value) =>
            this.onChangeCustomQty(event, value, index)
          }
          placeholder="qty"
        />
      </TableRowColumn>
      <TableRowColumn style={{ width: 50 }}>
        <Field
          label=""
          name={`${customs}.price`}
          parse={v => v * 1}
          component={TextField}
          onChange={(event, value) =>
            this.onChangeCustomPrice(event, value, index)
          }
          placeholder="price"
        />
      </TableRowColumn>
      <TableRowColumn style={{ width: 80 }}>
        <Field
          label=""
          name={`${customs}.subtotal`}
          parse={v => v * 1}
          component={renderTextFieldView}
          placeholder="total"
        />
      </TableRowColumn>
      <TableRowColumn style={{ textAlign: "right", width: 30 }}>
        <FlatButton
          primary
          label=""
          onClick={() => fields.remove(index)}
          icon={<ActionDelete />}
        />
      </TableRowColumn>
    </TableRow>
  );
  renderCustomList = ({ fields }) => {
    return (
      <Responsive
        small={
          <Table selectable={false}>
            <TableBody displayRowCheckbox={false}>
              {fields.map(this.renderCustomFieldsSmall.bind())}
            </TableBody>
            <TableFooter adjustForCheckbox={false}>
              <TableRow>
                <TableRowColumn style={{ textAlign: "center" }}>
                  <FlatButton
                    primary
                    label="add Custom line"
                    onClick={() => fields.push({})}
                    icon={<ContentAdd />}
                  />
                </TableRowColumn>
              </TableRow>
            </TableFooter>
          </Table>
        }
        medium={
          <Table selectable={false}>
            <TableBody displayRowCheckbox={false}>
              {fields.map(this.renderCustomFields.bind())}
            </TableBody>
            <TableFooter adjustForCheckbox={false}>
              <TableRow>
                <TableRowColumn style={{ textAlign: "center" }}>
                  <FlatButton
                    primary
                    label="add Custom line"
                    onClick={() => fields.push({})}
                    icon={<ContentAdd />}
                  />
                </TableRowColumn>
              </TableRow>
            </TableFooter>
          </Table>
        }
      />
    );
  };
  onChangeCustomQty = (event, value, index) => {
    if (!this.props.customs[index].subtotal) {
      this.props.customs[index].subtotal = 0;
    }
    this.props.customs[index].qty = value;
    this.props.customs[index].subtotal =
      this.props.customs[index].price * value;
    this.handleCustomTotal();
  };

  onChangeCustomPrice = (event, value, index) => {
    this.props.customs[index].price = value;
    this.props.customs[index].subtotal = this.props.customs[index].qty * value;
    this.handleCustomTotal();
  };

  handleCustomTotal = () => {
    let customTotal = 0;
    let total_items = 0;
    let itemsTotal = 0;
    if (this.props.items != null && this.props.items.length > 0) {
      itemsTotal = this.props.items.length;
    }
    if (this.props.customs != null && this.props.customs.length > 0) {
      for (let i = 0; i < this.props.customs.length; i++) {
        if (!isNaN(this.props.customs[i].subtotal)) {
          customTotal = this.props.customs[i].subtotal + customTotal;
          // console.log("masuk ==>"+customTotal);
        }
      }
      total_items = itemsTotal + this.props.customs.length;
    } else {
      total_items = itemsTotal;
    }

    let subtotal = this.state.subtotal;
    let total = subtotal + customTotal;
    this.setState({
      customTotal: customTotal,
      total: total
    });
    this.props.amounts.total = total;
    this.props.amounts.custom = customTotal;
    this.props.amounts.total_items = total_items;
  };

  render() {
    const {
      children,
      invalid,
      record,
      resource,
      basePath,
      submitOnEnter,
      toolbar
    } = this.props;
    return (
      <div>
        <form className="simple-form">
          <DivContainer>
            <HeaderForm>
              <div />
              <HeaderDateTime>
                <Field
                  label="Issue Date"
                  name="issued_at"
                  component={renderDateField}
                />
                &nbsp;
                <Field
                  label="time"
                  name="issued_at"
                  component={renderTimeField}
                />
              </HeaderDateTime>
            </HeaderForm>
            <DivStatus>
              <Field label="Status" name="status" component={renderSelectField}>
                <MenuItem
                  value="pending payment"
                  primaryText="Pending Payment"
                />
                <MenuItem value="paid" primaryText="Paid" />
                <MenuItem value="delivered" primaryText="Delivered" />
                {/* <MenuItem value="invoiced" primaryText="Invoice"/>
                <MenuItem value="expired" primaryText="Expired"/> */}
                <MenuItem value="preparing" primaryText="Preparing" />
                <MenuItem
                  value="out for delivery"
                  primaryText="Out for Delivery"
                />
                <MenuItem value="rejected" primaryText="Rejected" />
                <MenuItem value="cancelled" primaryText="Cancelled" />
              </Field>
            </DivStatus>
            {this.renderTItle("Customer")}
            <Divider />
            <DivCustomerInfo>
              <DivCustomerInfoBox>
                <Field
                  name="customer_info.first_name"
                  component={TextField}
                  floatingLabelText="First Name"
                  fullWidth={true}
                />
                <Field
                  name="customer_info.last_name"
                  component={TextField}
                  floatingLabelText="Family Name"
                  fullWidth={true}
                />
                <Field
                  name="customer_info.email"
                  component={TextField}
                  floatingLabelText="Email"
                  fullWidth={true}
                />
                <Field
                  name="customer_info.phone"
                  component={TextField}
                  floatingLabelText="Phone"
                  fullWidth={true}
                />
              </DivCustomerInfoBox>
              <DivCustomerInfoBox1>
                <Field
                  name="customer_info.country"
                  component={TextField}
                  floatingLabelText="Country"
                  fullWidth={true}
                />
                <Field
                  name="customer_info.province"
                  component={TextField}
                  floatingLabelText="Province"
                  fullWidth={true}
                />
                <Field
                  name="customer_info.city"
                  component={TextField}
                  floatingLabelText="City"
                  fullWidth={true}
                />
                <Field
                  name="customer_info.zip"
                  component={TextField}
                  floatingLabelText="Postal / Zip"
                />
                <Field
                  name="customer_info.address"
                  component={renderMultiTextField}
                  label="Address"
                />
              </DivCustomerInfoBox1>
            </DivCustomerInfo>
            {this.renderTItle("Items")}
            <Divider />
            <div>
              <FieldArray name="items" component={this.renderItemList.bind()} />
            </div>
            {this.renderTItle("Customs Line")}
            <Divider />
            <div>
              <FieldArray name="customs" component={this.renderCustomList} />
            </div>
            <DivTotal>
              <DivFieldTotal>
                <Field
                  name="note"
                  component={renderMultiTextField}
                  label="Note"
                />
                {React.Children.map(
                  children,
                  input =>
                    input &&
                    input.props.source === "tracking" &&
                    this.renderField({ input, resource, record, basePath })
                )}
              </DivFieldTotal>
              <DivOrderTotal>
                <Divider />
                <DivSubTotal>
                  <div>Subtotal </div>
                  <div>{this.state.subtotal} </div>
                </DivSubTotal>
                <DivSubTotal>
                  <div>Custom </div>
                  <div>{this.state.customTotal}</div>
                </DivSubTotal>
                <DivSubTotal>
                  <div>Coupon </div>
                  <div>{this.state.coupon}</div>
                </DivSubTotal>
                <DivSubTotal>
                  <div> Shipping </div>
                  <div>{this.state.shipping}</div>
                </DivSubTotal>
                <DivSubTotal>
                  <div>Total </div>
                  <div>{this.state.total}</div>
                </DivSubTotal>
              </DivOrderTotal>
            </DivTotal>
          </DivContainer>
          {toolbar &&
            React.cloneElement(toolbar, {
              handleSubmitWithRedirect: this.handleSubmitWithRedirect,
              invalid,
              submitOnEnter
            })}
        </form>
      </div>
    );
  }
}
/*<div style={{width:400}}>
  <Values form="record-form" />
</div>*/
OrderForm.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  defaultValue: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.func
  ]),
  handleSubmit: PropTypes.func, // passed by redux-form
  invalid: PropTypes.bool,
  record: PropTypes.object,
  resource: PropTypes.string,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  save: PropTypes.func, // the handler defined in the parent, which triggers the REST submission
  submitOnEnter: PropTypes.bool,
  toolbar: PropTypes.element,
  validate: PropTypes.func
};

OrderForm.defaultProps = {
  submitOnEnter: false,
  toolbar: <Toolbar />
};

const selector = formValueSelector("record-form");
const enhance = compose(
  connect(
    (state, props) => {
      const issued_at = selector(state, "issued_at");
      const customer_id = selector(state, "customer_id");
      const customer_info = selector(state, "customer_info");
      const items = selector(state, "items");
      const customs = selector(state, "customs");
      const amounts = selector(state, "amounts");

      return {
        initialValues: getDefaultValues(state, props),
        issued_at,
        customer_id,
        customer_info,
        items,
        customs,
        amounts
      };
    },
    { setSidebarVisibility }
  ),
  reduxForm({
    form: "record-form",
    enableReinitialize: true
  })
);

export default enhance(OrderForm);



// WEBPACK FOOTER //
// ./src/orders/OrderForm.js